import { IReviewCreateBody } from '../../../interfaces/reviews';

export enum REVIEW_FIELDS {
  ORGANIZATION_TYPE = 'organizationType',
  ORGANIZATION_ID = 'organizationId',
  RATING = 'rating',
  LOCATION_GAR_ID = 'locationGarId',
  TITLE = 'title',
  TEXT = 'text',
  SERVICE = 'service',
  IS_LEGAL = 'isLegal',
  PRODUCT_ID = 'productId',
  // информация о юзере
  USER_NAME = 'userName',
  BIRTHDAY = 'userBirthday',
  USER_PHONE = 'userPhone',
  MESSAGE_FOR_COMPANY = 'messageForCompany',
  ATTACHMENTS = 'attachments',
  // техническая информация
  AGREEMENT = 'agreement',
  IS_USER_READY_TO_SUBMIT = 'isUserReadyToSubmit',
  ID = 'id',
}

export const FIELDS_FOR_UPDATING_PERSONAL_DATA: Array<keyof IReviewCreateBody> = [
  'id',
  'messageForCompany',
  'attachments',
  'reviewUserData',
  'reviewObjectId', // нужен для ручки обновления данных, но не является персональным полем
  'additionalInfoUiConfiguration',
  'additionalJsonData',
  'schemeTemplateId',
];

export const LENGTH_MAX = {
  [REVIEW_FIELDS.TITLE]: 100,
  [REVIEW_FIELDS.TEXT]: 2000,
  [REVIEW_FIELDS.MESSAGE_FOR_COMPANY]: 4000,
  [REVIEW_FIELDS.USER_NAME]: 150,
};

export const LENGTH_MIN = {
  [REVIEW_FIELDS.TITLE]: 10,
  [REVIEW_FIELDS.TEXT]: 100,
};

export const AGE_MIN = 14;
export const AGE_MAX = 121;

export const TEXT_FIELDS = [
  REVIEW_FIELDS.TITLE,
  REVIEW_FIELDS.TEXT,
  REVIEW_FIELDS.USER_NAME,
  REVIEW_FIELDS.MESSAGE_FOR_COMPANY,
];
